export default __webpack_public_path__ + "static/media/mamut_background_xl1.e87802d0.jpg";